module.exports = __webpack_public_path__ + "static/media/whatsapp_icon.0df55097.svg";